import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'
import { isNil } from 'ramda'
import { Ticket_State_Priority, Ticket_Status_Code } from 'generated/types'

class TicketState extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> TicketState constructor -', init)
    if (isNil(init)) return undefined
    this._active = init.active
    this._code = init.code
    this._display_name = init.display_name
    this._priority = init.priority
  }

  static shape = {
    id: PropTypes.string.isRequired,
    active: PropTypes.bool,
    code: PropTypes.string,
    display_name: PropTypes.string,
    priority: PropTypes.number
  }

  get active() {
    return this._active
  }

  get code() {
    return this._code
  }

  get display_name() {
    return this._display_name
  }

  get priority() {
    return this._priority
  }

  // Calculable
  get isPending() {
    return this._code === Ticket_Status_Code.Pending
  }

  get isPendingNew() {
    return this._priority === Ticket_State_Priority.PendingNew
  }

  get isPendingWaiting() {
    return this._priority === Ticket_State_Priority.PendingWaiting
  }

  get isPendingAssigned() {
    return this._priority === Ticket_State_Priority.PendingAssigned
  }

  get isInProgress() {
    return this._code === Ticket_Status_Code.InProgress
  }

  get isInProgressNavigator() {
    return this._priority === Ticket_State_Priority.InProgressNavigator
  }

  get isInProgressWaiting() {
    return this._priority === Ticket_State_Priority.InProgressWaiting
  }

  get isClosed() {
    return this._code === Ticket_Status_Code.Closed
  }

  get isReadyToClose() {
    return this._priority === Ticket_State_Priority.ClosedReadyToClose
  }

  get isResolved() {
    return this._priority === Ticket_State_Priority.ClosedResolved
  }

  get isUnresolved() {
    return this._priority === Ticket_State_Priority.ClosedUnresolved
  }

  get isOpen() {
    return (
      this._priority !== Ticket_State_Priority.ClosedResolved &&
      this._priority !== Ticket_State_Priority.ClosedUnresolved
    )
  }
}

export default TicketState
